import React, { Component } from 'react';
import { Button, Modal } from 'react-bootstrap';
import OverlayLoader from './overlayLoader';
import './common.css';
import setTitleToFilters from '../common/filtersTitles';

export default class EditingDataHistoryDialog extends Component {
  constructor(props) {
    super(props);
    this.onShow = this.onShow.bind(this);
  }

  componentDidUpdate() {
    setTitleToFilters();
  }

  onShow() {
    this.props.fetchHistory(this.dataId);
  }

  get dataId() {
    throw new Error("DataId is not defined!");
  }

  get Title() {
    throw new Error("Title is not defined!");
  }

  render() {
    return (
      <Modal bsSize="lg" show={this.props.show} onShow={this.onShow} onHide={this.props.onClose} backdrop="static">
        <Modal.Header>
          <Modal.Title>{this.Title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <OverlayLoader
            active={this.isLodaing()}
            text={this.getLoaderMessage()}
          >
            <div>
              {this.renderBeforeContent()}
              {this.renderContent()}
            </div>
          </OverlayLoader>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.props.onClose}>Close</Button>
        </Modal.Footer>
      </Modal>
    );
  }

  renderTable(tableProps) {
    throw new Error("Table rendering is not defined!");
  }

  renderBeforeContent() {
    return null;
  }

  renderContent() {
    if (this.props.objectState.error)
      return this.renderError();
    return this.renderTable({ history: this.props.objectState.data });
  }

  renderError() {
    return (
      <p className="text-danger">Error: {this.props.objectState.error.toString()}</p>
    );
  }

  isLodaing() {
    return this.props.objectState.isFetching;
  }

  getLoaderMessage() {
    throw new Error("Loader message is not defined!");
  }
}



// WEBPACK FOOTER //
// ./src/components/editingDataHistoryDialog.js